import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ChevronDownIcon } from '@chakra-ui/icons'
import {
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text,
  Avatar,
  Button
} from '@chakra-ui/react'

import { useAuth } from 'modules/auth'

export const HeaderProfile = props => {
  const navigate = useNavigate()
  const { auth, logout } = useAuth()

  return (
    <Flex>
      {auth ? (
        <Menu>
          <MenuButton>
            <Flex align='center'>
              <Avatar size='sm' bg='teal.500' />
              <Box ml={3} textAlign='left'>
                <Text>{auth.name}</Text>
              </Box>
              <ChevronDownIcon ml={2} />
            </Flex>
          </MenuButton>
          <MenuList>
            <MenuItem onClick={() => logout()}>Logout</MenuItem>
          </MenuList>
        </Menu>
      ) : (
        <Button variant='outline' onClick={() => navigate('/login')}>
          Login
        </Button>
      )}
    </Flex>
  )
}

export default HeaderProfile
